module.exports = __webpack_public_path__ + "img/adhesivo_para_muros_y_pisos.ad9d0101.png";